module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/hero-09000d1479067472b3c904422877a2fa.png";